export default [
    "市场就像大赌场，别人都在喝酒，如果你坚持喝可乐，就会没事。",
    "别人恐惧我贪婪，别人贪婪我恐惧。",
    "耐不住寂寞，拿不住钞票。",
    "赚钱的空间是跌出来的。",
    "会买的是徒弟，会卖的是师傅，会休息的是师爷。",
    "买入前要小心求证，买入时要三思而行。",
    "股市两样宝，好马加快刀。获利跑得快，割肉用快刀。",
    "以市场为师，践学不悔，敏学不倦，谦学不怠。",
    "投资必须是理性的，如果你不理解它，请不要做。",
    "想成为最优秀的人，就要向最优秀的人学习。",
    "股票场是财富的再分配系统。它将金钱从那些没有耐心的人身上夺走，并分配给那些富有耐心的人。",
    "常赚比大赚更重要，它不仅使你的资金雪球越滚越大，而且可以令你保持一个良好的心态。",
    "顺着大势做股票胜算大，其他都是次要的。",
    "严格控制风险、持续稳定赢利才是真正的英雄！",
    "长线买的是公司，中线买的是趋势，短线买的是庄家。",
    "放开脑袋，不排斥他人的操作思维，验证他人的手法，不断学习他人的长处！",
    "不断地吸纳股性，不断地忘却人性，只有这样，才能与市场融为一体。",
    "看不懂、看不准、没把握时坚决不进场。",
    "君子问凶不问吉，高手看盘先看跌。",
    "涨时重势，跌时重质。",
    "最大的利好是跌过头，最大的利空是涨过头。",
    "能够亏损的最大范围，就是你能够投资的最大极限。",
    "不要把所有的财产都投入股市，更切忌借贷资金购买股票。",
    "买进靠耐心，卖出靠决心，休息靠信心。",
    "只要比别人多冷静一分，便能在股市中脱颖而出。",
    "不要妄想在最低价买进，于最高价卖出。",
    "赚到手就存起来，等于把利润的一半锁进保险箱。",
    "看大方向赚大钱，看小方向赚小钱。",
    "黑马股可遇不可求，投资胜票仍应以踏实为主。",
    "价格是你付出的，而价值才是你得到的。",
    "以合理的价格投资优异的公司胜于以优异的价格投资平庸的公司。",
    "只有在退潮的时候，你才知道谁一直在光着身子游泳。",
    "如果你想等到看见隧道另一端的光明时才买卖股票，那就未免太迟了。",
    "自古圣者皆寂寞，惟有忍者能其贤。",
    "伴君如伴虎，跟庄如跟狼。",
    "老手多等待，新手多无耐(心)。",
    "心态第一，策略第二，技术只有屈居第三了。",
    "钓鱼的第一条规则是，在有鱼的地方钓鱼。钓鱼的第二条规则是，记住第一条规则。",
    "投资正确的做法应该是逆向投资：在人们冷落时买入，在人们追捧时卖出。",
    "市场短期是一台投票机，但长期是一台称重机。",
    "最终决定投资者命运的不是股票市场，甚至也不是上市公司，而是你自己。",
    "要得到你想要的某样东西，最可靠的办法是让你自己配得上它。",
    "投资就像运动一样，胜败是一时的，风格是永久的。",
    "风险来自于你不知道自己在做什么。",
    "选股不如选时，善买不如善卖。",
    "永远不要孤注一掷。"
]